import { Props } from './Bubble';
import { OptionsBubble } from './OptionsBubble';
import { ChoiceType } from '@raysee/schema';

export const ConfirmationResultBubble = (props: Props) => (
  <OptionsBubble {...props} choices={[ChoiceType.Yes, ChoiceType.No]} />
);
